import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShareableLinkField } from 'components/FormFields';
import SimpleModal from 'components/SimpleModal';
import { jsx as _jsx } from "react/jsx-runtime";
function CopyContentLinkModal(_ref) {
  var contentId = _ref.contentId,
    parentPlaylistId = _ref.parentPlaylistId,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'asset' : _ref$type,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    width: "wide",
    title: t('actions_get_shareable_link'),
    body: /*#__PURE__*/_jsx(ShareableLinkField, {
      horizontal: true,
      type: type,
      contentId: contentId,
      parentPlaylistId: parentPlaylistId
    }),
    buttons: [{
      label: t('actions_done'),
      onClick: onClose,
      variant: 'primary',
      icon: 'ok'
    }],
    onClose: onClose
  });
}
export default CopyContentLinkModal;